(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var rounded = Math.round(cents / 100);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(rounded))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(rounded))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('form.product-form');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var priceEl = document.getElementById('price-display');
    var subtotalEl = document.getElementById('framed-demo-subtotal');
    var atcBtn = document.getElementById('atc-btn');
    var stickyAtc = document.getElementById('sticky-atc');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    var commerceRail = document.getElementById('commerce-rail');
    var stickyMeta = document.getElementById('sticky-atc-meta');
    var strings = (window.theme && window.theme.strings) || {};
    var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    var addLabel = strings.addToCart || 'Add to cart';
    var addingLabel = strings.adding || 'Adding…';
    var soldOutLabel = strings.soldOut || 'Sold out';

    var configEl = document.getElementById('framed-demo-config');
    var demo = null;
    if (configEl) {
      try { demo = JSON.parse(configEl.textContent); }
      catch (error) { if (window.console) window.console.warn('Framed demo configuration could not be read.', error); }
    }

    var heroImg = document.getElementById('gallery-hero');
    var galleryButtons = [].slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var galleryHero = heroImg && heroImg.closest('.gallery-hero');
    var galleryTarget = '';
    var galleryError = document.createElement('p');
    galleryError.className = 'gallery-error';
    galleryError.hidden = true;
    galleryError.setAttribute('role', 'status');
    if (demo && galleryHero) galleryHero.appendChild(galleryError);
    var galleryRequest = 0;


    var frameViews = galleryHero ? [].slice.call(galleryHero.querySelectorAll('[data-fp-view]')) : [];

    function showGalleryImage(src, alt) {
      if (!heroImg || !src) return;
      delete galleryHero.dataset.fpActive;
      frameViews.forEach(function(view) { view.hidden = true; });
      heroImg.hidden = false;
      var request = ++galleryRequest;
      galleryTarget = src;
      galleryError.hidden = true;
      if (heroImg.dataset.activeSrc === src && heroImg.complete && heroImg.naturalWidth) {
        heroImg.alt = alt || '';
        galleryHero.removeAttribute('aria-busy');
        return;
      }
      var incoming = new Image();
      incoming.onload = function () {
        if (request !== galleryRequest || galleryTarget !== src) return;
        heroImg.removeAttribute('srcset');
        heroImg.src = src;
        heroImg.dataset.activeSrc = src;
        heroImg.dataset.zoomSrc = src;
        heroImg.alt = alt || '';
        galleryHero.removeAttribute('aria-busy');
      };
      incoming.onerror = function () {
        if (request !== galleryRequest) return;
        if (demo) {
          galleryHero.setAttribute('aria-busy', 'true');
          galleryError.textContent = demo.strings.imageError;
          galleryError.hidden = false;
        }
      };
      incoming.src = src;
    }

    function setActiveGalleryButton(button) {
      if (!button || button.hidden) return;
      galleryButtons.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        if (demo) item.tabIndex = item === button ? 0 : -1;
      });
      showGalleryImage(button.dataset.fullSrc, button.dataset.alt);
    }

    var variantButtons = [].slice.call(document.querySelectorAll('[data-variant-id]'));
    var sizeButtons = demo ? [].slice.call(document.querySelectorAll('[data-size-key]')) : variantButtons;
    var presentationButtons = [].slice.call(document.querySelectorAll('[data-presentation]'));
    var selectionEl = document.querySelector('[data-demo-selection]');
    var surchargeEl = document.querySelector('[data-frame-surcharge]');
    var selectedVariant = null;
    var selectedExactVariant = null;
    var selectedPresentation = demo ? demo.defaultPresentation : 'print';

    function selectedSize() {
      return selectedVariant && selectedVariant.dataset.sizeKey || '';
    }

    function sizeKey(value) {
      value = String(value || '').toLowerCase();
      return value === 'medium' || value === 'mittel' ? 'medium' : 'large';
    }

    function exactVariant(size, presentation) {
      if (!demo || !demo.variants) return null;
      return demo.variants.find(function (variant) {
        return variant.options && sizeKey(variant.options[0]) === size && variant.presentation === presentation;
      }) || null;
    }

    function updateUrl(mode) {
      if (!demo || !selectedVariant) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedExactVariant ? selectedExactVariant.id : selectedVariant.dataset.variantId);
      url.searchParams.set('presentation', selectedPresentation);
      if (mode === 'push') window.history.pushState({}, '', url);
      else if (mode === 'replace') window.history.replaceState({}, '', url);
    }

    function updatePurchaseState(available) {
      [atcBtn, stickyBtn].forEach(function (button) {
        if (!button) return;
        button.classList.remove('is-preview-only');
        button.disabled = !available;
        button.textContent = available ? addLabel : soldOutLabel;
      });
    }

    // Framed-print sample viewer, as on patkay.studio: two panels side by side
    // (frame preview, interior preview) in a scroll-snap track. The tabs slide
    // the track; swiping it moves the tabs. Each panel holds one print whose
    // geometry changes in place on a size or framing change; CSS eases the
    // print size, frame face and mat together (0.34s, cubic-bezier(.2,.7,.2,1)).
    // A framing change swaps the frame and mat at once and eases only the
    // size, as Patkay's frame swatches do (is-frame-swap, framed-print.css).
    var viewTrack = galleryHero && galleryHero.querySelector('[data-view-track]');
    var viewSlides = viewTrack ? [].slice.call(viewTrack.querySelectorAll('[data-view-slide]')) : [];
    var viewTabs = [].slice.call(document.querySelectorAll('[data-view-tab]'));
    var currentSlide = 'frame';
    var shownPresentation = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setCurrentSlide(name, scroll) {
      var index = viewSlides.findIndex(function (slide) { return slide.dataset.viewSlide === name; });
      if (index === -1) return;
      currentSlide = name;
      viewSlides.forEach(function (slide) { slide.classList.toggle('is-current', slide.dataset.viewSlide === name); });
      viewTabs.forEach(function (tab) {
        var active = tab.dataset.viewTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      if (scroll) viewTrack.scrollTo({ left: viewSlides[index].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function settleSlide() {
      var index = Math.round(viewTrack.scrollLeft / Math.max(1, viewTrack.clientWidth));
      var slide = viewSlides[Math.min(viewSlides.length - 1, Math.max(0, index))];
      if (slide && slide.dataset.viewSlide !== currentSlide) setCurrentSlide(slide.dataset.viewSlide, false);
    }

    if (viewTrack) {
      var settleTimer = null;
      viewTrack.addEventListener('scroll', function () {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settleSlide, 120);
      }, { passive: true });
      viewTrack.addEventListener('scrollend', function () {
        window.clearTimeout(settleTimer);
        settleSlide();
      });
    }

    if (viewTrack && 'ResizeObserver' in window) {
      var trackWidth = viewTrack.clientWidth;
      new ResizeObserver(function () {
        if (trackWidth === viewTrack.clientWidth) return;
        trackWidth = viewTrack.clientWidth;
        var slide = viewSlides.find(function (item) { return item.dataset.viewSlide === currentSlide; });
        if (slide) viewTrack.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
      }).observe(viewTrack);
    }

    viewTabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setCurrentSlide(tab.dataset.viewTab, true); });
      tab.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var index = viewTabs.indexOf(tab);
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? viewTabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + viewTabs.length) % viewTabs.length;
        viewTabs[next].focus();
        setCurrentSlide(viewTabs[next].dataset.viewTab, true);
      });
    });

    if (demo && heroImg) {
      heroImg.addEventListener('error', function () {
        galleryError.textContent = demo.strings.imageError;
        galleryError.hidden = false;
      });
    }

    function easeFrameChange(container, sizing, finalStyle, previousPhoto, widthProperty, heightProperty) {
      var photo = container.querySelector('.fp__image');
      var nextPhoto = photo && photo.getBoundingClientRect();
      if (previousPhoto && nextPhoto && previousPhoto.width > 0 && previousPhoto.height > 0 && nextPhoto.width > 0 && nextPhoto.height > 0) {
        var width = parseFloat(sizing.style.getPropertyValue(widthProperty));
        var height = parseFloat(sizing.style.getPropertyValue(heightProperty));
        sizing.style.setProperty(widthProperty, width * previousPhoto.width / nextPhoto.width + '%');
        sizing.style.setProperty(heightProperty, height * previousPhoto.height / nextPhoto.height + '%');
        void container.offsetWidth;
        container.classList.remove('is-instant');
        void container.offsetWidth;
        sizing.setAttribute('style', finalStyle);
      } else {
        void container.offsetWidth;
        container.classList.remove('is-instant');
      }
    }

    function syncDemoViews(animate) {
      if (!demo || !selectedVariant || !viewSlides.length) return;
      var size = selectedSize();
      var framed = selectedPresentation === 'framed';
      var key = size + '-' + (framed ? 'framed' : 'print');
      var frameSwap = shownPresentation !== null && shownPresentation !== selectedPresentation;
      var wall = galleryHero.querySelector('.wall[data-wall-medium-framed]');
      galleryError.hidden = true;
      viewSlides.forEach(function (slide) {
        var instant = !animate || slide.dataset.viewSlide !== currentSlide || reduceMotion.matches;
        var photo = slide.querySelector('.fp__image');
        var previousPhoto = frameSwap && !instant && photo ? photo.getBoundingClientRect() : null;
        var slideWall = slide.querySelector('.wall[data-wall-medium-framed]');
        if (slideWall) {
          // Room panel: one print, its shadow and the light map follow the new
          // geometry together; CSS eases the sizes (0.34s, Patkay's curve).
          var wallStyle = slideWall.getAttribute('data-wall-' + key);
          var printStyle = slideWall.getAttribute('data-fp-' + key);
          var wallPrint = slideWall.querySelector('.wall__print .fp');
          if (instant || frameSwap) slideWall.classList.add('is-instant');
          slideWall.classList.toggle('is-frame-swap', frameSwap && !instant);
          if (wallStyle && slideWall.getAttribute('style') !== wallStyle) slideWall.setAttribute('style', wallStyle);
          if (wallPrint && printStyle) {
            wallPrint.setAttribute('style', printStyle);
            wallPrint.classList.toggle('fp--framed', framed);
            wallPrint.classList.toggle('fp--print', !framed);
            wallPrint.dataset.fpSize = size;
          }
          if (previousPhoto && wallStyle) {
            easeFrameChange(slideWall, slideWall, wallStyle, previousPhoto, '--wall-width', '--wall-height');
          } else if (instant || frameSwap) {
            void slideWall.offsetWidth;
            slideWall.classList.remove('is-instant');
          }
          return;
        }
        var front = slide.querySelector('[data-fp-medium-framed]');
        if (!front) return;
        // Frame panel: the same print stays on screen with or without a frame,
        // as on patkay.studio, so a change never waits for another photo. The
        // unframed geometry is the one the room panel already carries.
        var frontPrint = front.querySelector('.fp');
        var frontStyle = front.getAttribute('data-fp-' + key) || (wall && wall.getAttribute('data-fp-' + key));
        if (front.hidden) instant = true;
        if (instant || frameSwap) front.classList.add('is-instant');
        front.classList.toggle('is-frame-swap', frameSwap && !instant);
        if (frontPrint && frontStyle) {
          frontPrint.setAttribute('style', frontStyle);
          frontPrint.classList.toggle('fp--framed', framed);
          frontPrint.classList.toggle('fp--print', !framed);
          frontPrint.dataset.fpSize = size;
        }
        front.hidden = false;
        if (previousPhoto && frontPrint && frontStyle) {
          easeFrameChange(front, frontPrint, frontStyle, previousPhoto, '--fp-fit-w', '--fp-fit-h');
        } else if (instant || frameSwap) {
          void front.offsetWidth;
          front.classList.remove('is-instant');
        }
        if (heroImg && slide.contains(heroImg)) heroImg.hidden = true;
      });
      shownPresentation = selectedPresentation;
    }

    function applySelection(historyMode) {
      if (!selectedVariant) return;
      var size = selectedSize();
      selectedExactVariant = demo ? exactVariant(size, selectedPresentation) : null;
      var total = demo ? Number(selectedExactVariant && selectedExactVariant.price || 0) : parseInt(selectedVariant.dataset.price || '0', 10);
      var formatted = formatMoney(total);
      var available = demo ? !!(selectedExactVariant && selectedExactVariant.available) : (selectedVariant.dataset.available ? selectedVariant.dataset.available === 'true' : !selectedVariant.disabled);

      if (idInput) idInput.value = demo ? (selectedExactVariant ? selectedExactVariant.id : '') : selectedVariant.dataset.variantId;
      if (priceEl) priceEl.textContent = formatted;
      if (subtotalEl) subtotalEl.textContent = formatted;
      if (surchargeEl && demo) surchargeEl.textContent = formatMoney(Number(demo.surcharges[size] || 0));
      if (selectionEl && demo) selectionEl.textContent = demo.details[selectedPresentation][size];
      form.querySelectorAll('[data-size-measure]').forEach(function (measure) {
        measure.textContent = selectedPresentation === 'framed' ? measure.dataset.framedMeasure : measure.dataset.printMeasure;
      });
      if (stickyMeta) {
        var presentation = demo ? demo.strings[selectedPresentation] : '';
        var sizeTitle = demo ? (size === 'medium' ? 'Medium' : 'Large') : selectedVariant.dataset.variantTitle;
        stickyMeta.textContent = [sizeTitle, presentation, formatted].filter(Boolean).join(' · ');
      }

      sizeButtons.forEach(function (button) {
        var active = button === selectedVariant;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (demo) {
          var optionVariant = exactVariant(button.dataset.sizeKey, selectedPresentation);
          var price = button.querySelector('[data-option-price]');
          if (price) price.textContent = optionVariant ? formatMoney(optionVariant.price) + (optionVariant.available ? '' : ' ' + soldOutLabel) : soldOutLabel;
        }
      });
      presentationButtons.forEach(function (button) {
        var active = button.dataset.presentation === selectedPresentation;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      updatePurchaseState(available);
      syncDemoViews(historyMode === 'push');
      if (historyMode) updateUrl(historyMode);
    }

    function selectionFromUrl(historyMode) {
      var params = new URLSearchParams(window.location.search);
      var variantId = params.get('variant');
      if (demo) {
        var exact = demo.variants.find(function (variant) { return String(variant.id) === variantId; });
        var size = demo.defaultSize;
        selectedPresentation = params.get('presentation') === 'print' ? 'print' : demo.defaultPresentation;
        if (exact) {
          size = sizeKey(exact.options[0]);
          selectedPresentation = exact.presentation;
        }
        selectedVariant = sizeButtons.find(function (button) { return button.dataset.sizeKey === size; }) || sizeButtons[0];
      } else {
        selectedVariant = variantButtons.find(function (button) { return button.dataset.variantId === variantId && !button.disabled; }) ||
          variantButtons.find(function (button) { return button.classList.contains('is-active') && !button.disabled; }) ||
          variantButtons.find(function (button) { return !button.disabled; });
      }
      applySelection(historyMode);
    }

    galleryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.hidden) return;
        setActiveGalleryButton(button);
      });
      if (demo) button.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var visible = galleryButtons.filter(function (item) { return !item.hidden; });
        var index = visible.indexOf(button);
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + visible.length) % visible.length;
        if (visible[next]) { visible[next].focus(); visible[next].click(); }
      });
    });
    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectedVariant = button;
        applySelection(demo ? 'push' : null);
      });
    });
    presentationButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedPresentation = button.dataset.presentation;
        applySelection('push');
      });
    });

    selectionFromUrl(demo ? 'replace' : null);
    window.addEventListener('popstate', function () { selectionFromUrl(null); });

    function preloadGalleryImages() {
      galleryButtons.forEach(function (button) {
        if (!button.hidden && !button.classList.contains('is-active') && !button.dataset.fpSize && button.dataset.fullSrc) {
          var image = new Image();
          image.src = button.dataset.fullSrc;
        }
      });
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(preloadGalleryImages, { timeout: 1200 });
    else window.setTimeout(preloadGalleryImages, 400);

    var qtyVal = document.getElementById('qty-val');
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    var qty = 1;
    function syncQty() {
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (qtyMinus) qtyMinus.disabled = qty <= 1;
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () { if (qty > 1) { qty -= 1; syncQty(); } });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qty += 1; syncQty(); });
    syncQty();

    // Buy panel pin (desktop). It sticks 88px from the top; when the panel is
    // taller than the window that would cut off the shipping lines, so its top
    // is lifted just far enough to keep the last line in view. The panel ends
    // with about 38px of space under that line, so it may sit 16px past the
    // bottom edge of the window.
    var buySide = document.querySelector('.product-side');
    if (buySide && 'ResizeObserver' in window) {
      var sideDesktop = window.matchMedia('(min-width: 921px)');
      var fitBuySide = function () {
        if (!sideDesktop.matches) { buySide.style.removeProperty('top'); return; }
        var lift = window.innerHeight - buySide.offsetHeight + 16;
        if (lift < 88) buySide.style.top = Math.round(lift) + 'px';
        else buySide.style.removeProperty('top');
      };
      new ResizeObserver(fitBuySide).observe(buySide);
      window.addEventListener('resize', fitBuySide);
      fitBuySide();
    }

    var addingToCart = false;
    function submitProductForm(event) {
      if (event) event.preventDefault();
      if (!atcBtn || atcBtn.disabled || addingToCart) return;
      addingToCart = true;
      var addedToCart = false;
      var showedConfirmation = false;
      var trigger = event && event.currentTarget === stickyBtn ? stickyBtn : atcBtn;
      var hadError = false;
      atcBtn.classList.add('is-loading');
      atcBtn.setAttribute('aria-busy', 'true');
      if (stickyBtn) { stickyBtn.classList.add('is-loading'); stickyBtn.setAttribute('aria-busy', 'true'); }
      var formData = new FormData(form);
      fetch(rootUrl + 'cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json().then(function (data) { if (!response.ok) throw data; return data; });
        })
        .then(function (item) {
          addedToCart = true;
          item.quantity = parseInt(formData.get('quantity'), 10) || 1;
          if (demo) {
            item.ap_size_label = selectedSize() === 'medium' ? 'Medium' : 'Large';
            item.ap_presentation_label = demo.strings[selectedPresentation];
          }
          return fetch(rootUrl + 'cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (window.AhmadCart) {
            window.AhmadCart.refreshCount(cart.item_count);
            return window.AhmadCart.refreshDrawer();
          }
        })
        .then(function () { if (!showedConfirmation) { if (window.AhmadCart) window.AhmadCart.open(trigger); else if (window.showCartToast) window.showCartToast(); } })
        .catch(function (error) {
          if (addedToCart) {
            if (!showedConfirmation) { if (window.AhmadCart) window.AhmadCart.open(trigger); else if (window.showCartToast) window.showCartToast(); }
            return;
          }
          hadError = true;
          var message = error && (error.description || error.message);
          if (message) {
            atcBtn.textContent = message;
            if (window.console) window.console.warn('Cart add error:', message);
            window.setTimeout(function () { applySelection(null); }, 2600);
          } else form.submit();
        })
        .finally(function () {
          addingToCart = false;
          atcBtn.classList.remove('is-loading');
          atcBtn.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.classList.remove('is-loading');
          if (!hadError) applySelection(null);
        });
    }

    form.addEventListener('submit', submitProductForm);
    if (stickyBtn) stickyBtn.addEventListener('click', submitProductForm);

    if (stickyAtc && commerceRail && atcBtn) {
      var mobileBuyBar = window.matchMedia('(max-width: 920px)');
      var commerceInView = true;
      function syncStickyVisible() {
        var blocked = document.body.classList.contains('ap-panel-open');
        var show = mobileBuyBar.matches && atcBtn.getBoundingClientRect().bottom <= 0 && !blocked;
        stickyAtc.classList.toggle('is-visible', show);
        stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyAtc.inert = !show;
        // Preserve the existing page-space reservation independently of the
        // corrected button trigger, so the page's resting geometry stays fixed.
        var reserved = mobileBuyBar.matches && !commerceInView &&
          !document.body.classList.contains('cart-open') && !document.body.classList.contains('nav-open');
        document.body.classList.toggle('sticky-atc-on', reserved);
      }
      new IntersectionObserver(syncStickyVisible, { threshold: 0 }).observe(atcBtn);
      new IntersectionObserver(function (entries) {
        commerceInView = entries[0].isIntersecting;
        syncStickyVisible();
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' }).observe(commerceRail);
      var stickyTicking = false;
      window.addEventListener('scroll', function () {
        if (stickyTicking) return;
        stickyTicking = true;
        requestAnimationFrame(function () { syncStickyVisible(); stickyTicking = false; });
      }, { passive: true });
      document.addEventListener('ap:panelchange', syncStickyVisible);
      mobileBuyBar.addEventListener('change', syncStickyVisible);
      new MutationObserver(syncStickyVisible)
        .observe(document.body, { attributes: true, attributeFilter: ['class'] });
      syncStickyVisible();
    }
  });
})();


